module.exports = __webpack_public_path__ + "img/menu.2fd3cc79.svg";